/// <reference path="../../_ext/Editors/EditorDialogBase.ts" />
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class ProductionBOMDialog extends _Ext.MFGTransBOMEditorDialog<ProductionBOMRow> {
        protected getFormKey() { return ProductionBOMForm.formKey; }
    //    protected getIdProperty() { return ProductionBOMRow.idProperty; }
        protected getLocalTextPrefix() { return ProductionBOMRow.localTextPrefix; }
        protected getNameProperty() { return ProductionBOMRow.nameProperty; }
        //protected getService() { return ProductionBOMService.baseUrl; }
        //protected getDeletePermission() { return ProductionBOMRow.deletePermission; }
        //protected getInsertPermission() { return ProductionBOMRow.insertPermission; }
        //protected getUpdatePermission() { return ProductionBOMRow.updatePermission; }

        protected form = new ProductionBOMForm(this.idPrefix);
        constructor() {
            super();
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.BomAmount);
            q.setTextRightAlign(this.form.BomRate);
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.PureWeight);
            q.setTextRightAlign(this.form.Purity);

            this.form.BomRate.changeSelect2(e => { 
                if (this.form.CalcOnId.value == "3") {
                    this.form.BomAmount.value = this.form.Pieces.value * this.form.BomRate.value;

                } else if (this.form.CalcOnId.value == "4" || this.form.CalcOnId.value == "5") {

                    if (this.form.Purity.value > 0) {
                        this.form.BomAmount.value = this.form.Weight.value * this.form.BomRate.value * this.form.Purity.value;
                    }
                    else {
                        this.form.BomAmount.value = this.form.Weight.value * this.form.BomRate.value
                    }
                }

            });
            this.form.BomProductId.changeSelect2(e => {

                var productID = Q.toId(this.form.BomProductId.value);

                let prddetails: OMS.ProductMasterRow;
                OMS.ProductMasterService.Retrieve({
                    EntityId: productID
                }, response => {
                    prddetails = response.Entity
                }, { async: false });
                this.form.ProductCode.value =prddetails.ProductCode;

                this.form.Weight.value =prddetails.Weight;
                this.form.Pieces.value =prddetails.Pieces;

                if (productID != null) {
                    var att =prddetails.AttributeId;
                    var CalcOn =prddetails.CalcOnId;
                    var SubTypeID = 0;
                    var Rate = 0;

                    //this.form.Attribute.value = att.toString();
                    var AttID = att;//Q.toId(this.form.AttributeId.value);

                    this.form.AttributeId.value = AttID.toString();
                    if (this.form.ItemTypeId.value == 104) {
                        var std =prddetails.StdPurity;
                        var clr = prddetails.MetalColorId;
                        var karat = prddetails.KaratId;
                        SubTypeID = prddetails.SubCategoryId;


                        this.form.Purity.value = std;
                        this.form.PureWeight.value = std * this.form.Weight.value;
                        this.form.MetalColorId.value = clr.toString();
                        this.form.KaratId.value = karat.toString();
                       // this.form.ItemType.value = OMS.CommonAttributesRow.getLookup().itemById[AttID].ItemType;
                    }

                    if (this.form.ItemTypeId.value == 105) {
                        var shape = prddetails.ShapeId;
                        var quality = prddetails.QualityId;
                        var scolor = prddetails.StoneColorId;
                        //let Rate = GetItemRateHelper.GetPurchaseRate(att);
                        //this.form.BomRate.value = Rate;


                        this.form.ShapeId.value = shape.toString();
                        this.form.StoneColorId.value = scolor.toString();
                        this.form.QualityId.value = quality.toString();
                       // this.form.ItemType.value = OMS.CommonAttributesRow.getLookup().itemById[AttID].ItemType;
                    }


                    this.form.CalcOnId.value = CalcOn.toString();

                    if (SubTypeID == 301 || SubTypeID == 302 || SubTypeID == 303 || SubTypeID == 304) {
                        var MetalRate = GetItemRateHelper.GetGetMetalRate(SubTypeID);
                        this.form.BomRate.value = MetalRate;
                        //this.form.BomAmount.value = Rate * Weight * this.form.Purity.value;

                    }
                   

                }



            });
            this.form.Pieces.changeSelect2(e => {
                if (this.form.ItemTypeId.value == 105) {
                    //if (this.form.Pieces.value > this.oldpieces) {
                    //    Q.notifyWarning('Invalid Pieces');
                    //    return;
                    //}
                }
                if (this.form.CalcOnId.value == "3")
                    this.form.BomAmount.value = this.form.Pieces.value * this.form.BomRate.value;
            });
            this.form.Weight.changeSelect2(e => {
                if (this.form.ItemTypeId.value == 105) {
                    //if (this.form.Weight.value > this.oldweight) {
                    //    Q.notifyWarning('Invalid Weight');
                    //    return;
                    //}
                }
                if (this.form.CalcOnId.value == "4" || this.form.CalcOnId.value == "5") {
                    if (this.form.Purity.value > 0) {
                        this.form.PureWeight.value = this.form.Weight.value * this.form.Purity.value;
                        this.form.BomAmount.value = this.form.Weight.value * this.form.BomRate.value * this.form.Purity.value;
                    }
                    else {
                        this.form.BomAmount.value = this.form.Weight.value * this.form.BomRate.value
                    }
                } else {
                    if (this.form.Purity.value > 0) {
                        this.form.BomAmount.value = this.form.Weight.value * this.form.BomRate.value * this.form.Purity.value;

                    }
                }


            });

            // Validate Purity
            this.form.Purity.change(e => {
                var AttID = Q.toId(this.form.AttributeId.value); 
                if (AttID != null) {
                    var productID = this.form.BomProductId.value;

                    let prddetails;
                    OMS.ProductMasterService.Retrieve({
                        EntityId: productID
                    }, response => {
                        prddetails = response.Entity
                    }, { async: false });
                    var max = prddetails.MaxPurity;
                    var min = prddetails.MinPurity;
                    var std = prddetails.StdPurity;
                    var current = this.form.Purity.value;
                    if (std != undefined) {
                        if (current < min || current > max)
                            Q.alert("Enter Purity between  " + min.toString() + "  to  " + max.toString());
                    } else {
                        this.form.Purity.value = std;
                    }
                    this.form.PureWeight.value = this.form.Purity.value * this.form.Weight.value;


                }

            });

            this.form.ItemTypeId.changeSelect2(e => {
                if (this.form.ItemTypeId.value == 104) {
                    // Set read only to true for a field
                    this.form.BomProductId.value = "";
                    this.form.BomProductId.cascadeField = "ItemTypeId";
                    this.form.BomProductId.cascadeValue = this.form.ItemTypeId.value;
                    //this.form.PrdBomId.updateItems();
                    Serenity.EditorUtils.setReadOnly(this.form.KaratId, false);
                    Serenity.EditorUtils.setReadOnly(this.form.Purity, false);
                    Serenity.EditorUtils.setReadOnly(this.form.MetalColorId, false);
                    Serenity.EditorUtils.setReadOnly(this.form.ShapeId, true);
                    Serenity.EditorUtils.setReadOnly(this.form.QualityId, true);
                    Serenity.EditorUtils.setReadOnly(this.form.StoneColorId, true);
                    Serenity.EditorUtils.setReadOnly(this.form.Pieces, true);
                    Serenity.EditorUtils.setRequired(this.form.Pieces, false);
                } else if (this.form.ItemTypeId.value == 105) {
                    this.form.BomProductId.value = "";
                    this.form.BomProductId.cascadeField = "ItemTypeId";
                    this.form.BomProductId.cascadeValue = this.form.ItemTypeId.value;
                    Serenity.EditorUtils.setReadOnly(this.form.KaratId, true);
                    Serenity.EditorUtils.setReadOnly(this.form.Purity, true);
                    Serenity.EditorUtils.setReadOnly(this.form.MetalColorId, true);
                    Serenity.EditorUtils.setReadOnly(this.form.ShapeId, false);
                    Serenity.EditorUtils.setReadOnly(this.form.QualityId, false);
                    Serenity.EditorUtils.setReadOnly(this.form.StoneColorId, false);
                    Serenity.EditorUtils.setRequired(this.form.Pieces, true);
                    Serenity.EditorUtils.setReadOnly(this.form.Pieces, false);

                } else {
                    Serenity.EditorUtils.setReadOnly(this.form.KaratId, true);
                    Serenity.EditorUtils.setReadOnly(this.form.Purity, true);
                    Serenity.EditorUtils.setReadOnly(this.form.MetalColorId, true);
                    Serenity.EditorUtils.setReadOnly(this.form.ShapeId, true);
                    Serenity.EditorUtils.setReadOnly(this.form.QualityId, true);
                    Serenity.EditorUtils.setReadOnly(this.form.StoneColorId, true);

                }
            });
        }
        protected onDialogOpen() {
            this.setFields();
            this.setReadOnly(true);
        }

        protected setFields() {

            switch (this.form.ItemTypeId.value) {

                case 105: {
                    q.hideField(this.form.KaratId);
                    q.hideField(this.form.Purity);
                    q.hideField(this.form.MetalColorId);
                    q.hideField(this.form.Purity);
                    q.hideField(this.form.PureWeight);
                    q.showAndDisableField(this.form.ShapeId);
                    q.showAndDisableField(this.form.QualityId);
                    q.showAndDisableField(this.form.StoneColorId);
                    q.showAndDisableField(this.form.StoneSizeId);
                    q.showAndDisableField(this.form.SieveId);
                    q.showAndDisableField(this.form.Pieces);
                    var prdbomid = "";
                    if (this.form.BomProductId.value != "")
                        prdbomid = this.form.BomProductId.value;
                    this.form.BomProductId.cascadeField = "ItemTypeId";
                    this.form.BomProductId.cascadeValue = this.form.ItemTypeId.value;

                    this.form.BomProductId.value = prdbomid;
                    break;
                    //Serenity.EditorUtils.se
                }
                case 104: {
                    q.showAndDisableField(this.form.KaratId);
                    q.showAndDisableField(this.form.MetalColorId);
                    q.showAndDisableField(this.form.KaratId);
                    q.showAndDisableField(this.form.Purity);
                    q.showAndDisableField(this.form.PureWeight);

                    q.hideField(this.form.ShapeId);
                    q.hideField(this.form.QualityId);
                    q.hideField(this.form.StoneColorId);
                    q.hideField(this.form.StoneSizeId);
                    q.hideField(this.form.SieveId);
                    q.hideField(this.form.Pieces);

                    var prdbomid = "";
                    if (this.form.BomProductId.value != "")
                        prdbomid = this.form.BomProductId.value;
                    this.form.BomProductId.cascadeField = "ItemTypeId";
                    this.form.BomProductId.cascadeValue = this.form.ItemTypeId.value;
                    this.form.BomProductId.value = prdbomid;
                    break;
                }

                default: {
                    q.hideField(this.form.KaratId);
                    q.hideField(this.form.Purity);
                    q.hideField(this.form.MetalColorId);
                    q.hideField(this.form.ShapeId);
                    q.hideField(this.form.QualityId);
                    q.hideField(this.form.StoneColorId);
                    q.hideField(this.form.StoneSizeId);
                    q.hideField(this.form.SieveId);
                    Serenity.EditorUtils.setRequired(this.form.Pieces, false);
                    this.form.BomProductId.value = "";
                    this.form.BomProductId.cascadeField = "ItemTypeId";
                    this.form.BomProductId.cascadeValue = this.form.ItemTypeId.value;
                    break;
                }
            }
        }


        protected validateBeforeSave() {
            if (this.form.ItemTypeId.value == 104) {
                this.form.Pieces.value = 0;
            }
            return true;
        }

    }
}